import styled from 'styled-components';

export const IconsWrapper = styled.div`
    display: flex;
    gap: 20px;
`;
